// @ts-nocheck

import { MissionsStateActionTypes } from '../types/actions/missions';

export const requestOptInUser = ({ missionId }, hooks) => ({
  type: MissionsStateActionTypes.OPT_IN_REQUEST,
  payload: {
    missionId,
  },
  hooks,
});

const MissionsActionCreators = {
  requestOptInUser,
};

export default MissionsActionCreators;
